import _get from 'lodash/get';

export const isProduction = () =>
  _get(window, 'Grab.config.env') === 'production';

export const isDev = () =>
  _get(window, 'Grab.config.uri') === 'express.grab.dev';
